import { useEffect, useState } from "react";

export const ManipulateTextHOC = ({text, onClickCallback}) => {

    const [manipulatedText, setManipulatedText] = useState([]);

    useEffect(( ) => {
        let formattedText = text.replace(/HREFSTART(.*?)HREFEND/g, (value) => {
            let parts = value.split("#");
            return `<a href="${parts[2]}" target="_blank" className="link-color">${parts[1]}</a>`;
        });

        const clickSplits = formattedText.split(/CLICKSTART(.*?)CLICKEND/g);
        if ( clickSplits.length > 0 ) {
            setManipulatedText(clickSplits);
        } else {
            setManipulatedText(formattedText);
        }
        
    }, []);

    return (
        <div>
            {
                Array.isArray(manipulatedText) ? 
                manipulatedText.map(element => {
                    if ( element.startsWith('#') ) {
                        return <span className="link-color" role="button" onClick={() => { onClickCallback && onClickCallback(); }}>{element.replace(/#/g, '')}</span>
                    } else {
                        return <span dangerouslySetInnerHTML={{__html: element}}></span>
                    }
                }) : manipulatedText
            }
        </div>
    );
};